import { Memory } from '../../../types/types'
import Meta from '../../meta/Meta'

type Props = {
    memory: Memory
    shareType: string
    obit?: string
}

const MemoryMeta = ({ memory, shareType, obit }: Props) => {
    const sharedOid = obit
    // Create obituaryHeader for Meta tag
    const createObitHeaderText = () => {
        const obitData = memory.obituaries.find((o) => o.oid === sharedOid)
        const nodes = obitData?.text
        const header: string = nodes[0].children.map((p) => p.text).join('')
        return header
    }

    // Create first line in decription for Meta tag
    const createObitDescrText = () => {
        const obitData = memory.obituaries.find((o) => o.oid === sharedOid)
        const nodes = obitData?.text
        const descr: string = nodes[1].children.map((p) => p.text).join('')
        return descr
    }

    const { shareCards } = memory

    // Obituary card
    if (shareType === 'obit' && obit !== null) {
        return (
            <Meta
                title={`Minningarsíða - ${memory.fullName}`}
                type="website"
                seoTitle={`${createObitHeaderText()}`}
                description={`${createObitDescrText()}`}
                image={shareCards?.memory || ''}
                url={`https://minningar.is/memories/${memory.mid}?shared=obit&obit=${obit}#${obit}`}
            />
        )
    }
    // Memory announcement
    else if (shareType === 'announcement') {
        const announcementText = memory.announcements.deceased?.text
        return (
            <Meta
                title={`Minningarsíða - ${memory.fullName}`}
                type="website"
                seoTitle={`Andlátstilkynning - ${memory.fullName}`}
                description={announcementText}
                image={shareCards?.deceased || ''}
                // url={`https://minningar.is/memories/${memory.mid}?shared=announcement`}
                url={`https://minning-git-frikkibranch-kob.vercel.app/memories/${memory.mid}?shared=announcement`}
                keywords={`${memory.fullName}, minning`}
            />
        )
    }
    // Memory funeral
    else if (shareType === 'funeral') {
        const funeralText = memory.announcements.funeral?.text
        return (
            <Meta
                title={`Minningarsíða - ${memory.fullName}`}
                type="website"
                seoTitle={`Útfarartilkynning - ${memory.fullName}`}
                description={funeralText}
                image={shareCards?.funeral || ''}
                // url={`https://minningar.is/memories/${memory.mid}?shared=funeral`}
                url={`https://minning-git-frikkibranch-kob.vercel.app/memories/${memory.mid}?shared=funeral`}
                keywords={`${memory.fullName}, minning, minningarsíður`}
            />
        )
    }
    // Memory greeting
    else if (shareType === 'greeting') {
        const greetingText = memory.announcements.greeting?.text
        return (
            <Meta
                title={`Minningarsíða - ${memory.fullName}`}
                type="website"
                seoTitle={`Þakkir - ${memory.fullName}`}
                description={greetingText}
                image={shareCards?.greeting || ''}
                // url={`https://minningar.is/memories/${memory.mid}?shared=greeting`}
                url={`https://minning-git-frikkibranch-kob.vercel.app/memories/${memory.mid}?shared=greeting`}
                keywords={`${memory.fullName}, minning, minningarsíður`}
            />
        )
    }
    // Memory
    else {
        return (
            <Meta
                title={`Minningarsíða - ${memory.fullName}`}
                seoTitle={`Minningarsíða - ${memory.fullName}`}
                type="website"
                description={
                    memory.biography && memory.biography[1]?.children[0].text
                }
                image={shareCards?.memory || ''}
                // url={`https://minningar.is/memories/${memory.mid}`}
                url={`https://minning-git-frikkibranch-kob.vercel.app/memories/${memory.mid}`}
                keywords={`${memory.fullName}, minning, minningarsíður`}
            />
        )
    }
}

export default MemoryMeta
